import React from 'react';
import { FadeIn } from './FadeIn';
export function BonusClosing() {
  return <section className="py-10 sm:py-14 relative" data-id="element-22">
      <div className="mx-auto max-w-3xl px-6 lg:px-8 text-center" data-id="element-23">
        <div className="space-y-6 text-lg text-slate-300 font-sans leading-relaxed" data-id="element-24">
          <FadeIn data-id="element-25">
            <p className="text-slate-100 font-medium" data-id="element-26">
              Estos dos recursos no son opcionales.
            </p>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-27">
            <p data-id="element-28">Son las piezas que protegen tu inversión.</p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-29">
            <p data-id="element-30">
              Porque de nada sirve tener el protocolo principal si la primera
              noche improvisás en la madrugada.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-31">
            <p data-id="element-32">
              Y de nada sirve saber qué hacer si cada día lo hacés de forma
              diferente.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-33">
            <div className="bg-navy-light border border-gold/20 rounded-2xl p-8 mt-8" data-id="element-34">
              <p className="text-gold-light font-medium mb-4" data-id="element-35">
                El kit de emergencia te cubre cuando más lo necesitás.
              </p>
              <p className="text-gold-light font-medium" data-id="element-36">
                La rutina express te da la consistencia que hace que todo
                funcione.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-37">
            <p className="text-slate-100" data-id="element-38">
              Los dos vienen incluidos con tu acceso al ebook principal.
            </p>
          </FadeIn>

          <FadeIn delay={0.6} data-id="element-39">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-base" data-id="element-40">
              <span className="text-slate-400" data-id="element-41">Sin costo extra.</span>
              <span className="hidden sm:block text-slate-600" data-id="element-42">•</span>
              <span className="text-slate-400" data-id="element-43">Sin condiciones.</span>
              <span className="hidden sm:block text-slate-600" data-id="element-44">•</span>
              <span className="text-slate-400" data-id="element-45">Sin fecha de vencimiento.</span>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}